const ActionTypes = {
  GET_DOWNLOAD_OPTIONS: '[Application] Get Download Options',
  GET_DOWNLOAD_OPTIONS_SUCCESS: '[Application] Get Download Options Success',
  GET_DOWNLOAD_OPTIONS_FAIL: '[Application] Get Download Options Fail',
}

export class GetDownloadOptions {
  static type = ActionTypes.GET_DOWNLOAD_OPTIONS;
}

export class GetDownloadOptionsSuccess {
  static type = ActionTypes.GET_DOWNLOAD_OPTIONS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetDownloadOptionsFail {
  static type = ActionTypes.GET_DOWNLOAD_OPTIONS_FAIL;
}